import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../../../Loader"; // Optional loader

const CounterStyleThree = () => {
  const { page } = useSelector((state) => state.data);

  const [htmlContent, setHtmlContent] = useState(null);
  const [htmlContent2, setHtmlContent2] = useState(null);
  const [htmlContent3, setHtmlContent3] = useState(null);

  useEffect(() => {
    if (page && page.data) {
      const progress = page.data["progress"];
      const whyChooseUs = page.data["why-choose-us"];
      const serviceDesc = page.data["service-description"];

      if (progress?.siteId === 2 && progress.htmlContent) {
        setHtmlContent(progress.htmlContent);
      }

      if (whyChooseUs?.siteId === 2 && whyChooseUs.htmlContent) {
        setHtmlContent2(whyChooseUs.htmlContent);
      }

      if (serviceDesc?.siteId === 2 && serviceDesc.htmlContent) {
        setHtmlContent3(serviceDesc.htmlContent);
      }
    }
  }, [page]);

  return (
    <div className="rs-counter style3 modify1 pt-90 pb-80 md-pb-30">
      {htmlContent ? (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      ) : (
        <p>Loading Progress Content...</p> // or <Loader />
      )}
    </div>
  );
};

export default CounterStyleThree;